module.exports = __webpack_public_path__ + "static/img/en_US1.58da314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en_US1.png
// module id = xQBT
// module chunks = 1